import { apis } from './../../globals/resources';
import * as Type from './types';

export default class FaqExternalApi {
  private baseUrl = apis.webcometUrl;

  fetchFaq(
    faqId: string,
    params: Type.FetchFaqRequest,
    additionalHeaders: { [key: string]: string } = {}
  ): Promise<Response> {
    const url = new URL(`${this.baseUrl}/api/external/faq/v1/${faqId}`);

    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );

    /* eslint-disable @typescript-eslint/naming-convention */
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...additionalHeaders,
    };
    /* eslint-enable @typescript-eslint/naming-convention */

    return fetch(url.toString(), {
      method: 'GET',
      headers: headers,
    });
  }
}
